var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#173261"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12748 24.5L6.74548 16.008L4.17148 8.33H6.50348L7.80148 12.422L7.86748 12.73H7.95548L8.02148 12.422L9.31948 8.33H11.6515L9.07748 16.008L11.6955 24.5H9.36348L7.99948 19.682L7.95548 19.374H7.86748L7.82348 19.682L6.45948 24.5H4.12748ZM12.422 24.5V8.33H15.436L16.734 16.712L16.844 17.57H16.888L16.998 16.712L18.296 8.33H21.31V24.5H19.11V13.654H18.978L18.89 14.336L17.482 24.5H16.25L14.842 14.336L14.754 13.654H14.622V24.5H12.422ZM22.5942 24.5V8.33H24.9702V22.3H28.1162V24.5H22.5942Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/xml.af7d528f8311b3324db803b65c03caee.svg";
export { ForwardRef as ReactComponent };